// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import Sidebar from './sidebar';
import { isTokenValid } from '../utils/auth';

// Usamos una función que devuelve la ruta protegida o redirige
const PrivateRoute = ({ element }) => {
  const isAuthenticated = isTokenValid();

  return isAuthenticated ? (
    <div className="d-flex">
      <Sidebar />
      <div className="p-4 w-100">{element}</div>
    </div>
  ) : (
    <Navigate to="/login" />
  );
};
export default PrivateRoute;
